import Vue from 'vue';
import { mapGetters } from 'vuex';
import Backups from './backups';

export default Vue.component('admin-support', {
  template: require('./template.html'),
  name: 'admin-support',
  computed: {
    ...mapGetters(['currentUser']),
  },
  components: {
    Backups,
  },
  data() {
    return {
      border: '#2d2e33',
      tabs: [
        {
          label: 'Tickets',
          route: {
            name: 'admin-tickets',
            path: '/tickets',
          },
        },
        {
          label: 'Backups',
          route: {
            name: 'admin-backups',
            path: '/backups',
          },
        },
      ],
    };
  },
  methods: {
    matchRoute(tab) {
      const tabName = new RegExp(tab.route.name, 'gi');
      return this.$router.currentRoute.name.match(tabName);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/support/index.js